'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var updateSettings = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(settings, serviceConfig) {
    var accessToken, url, response, body;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _reactCookie2.default.load('access_token');
            url = serviceConfig.serviceUrl + '/user/settings';
            _context.next = 4;
            return fetch(accessToken ? url + '?accesstoken=' + accessToken : url, {
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'PUT',
              body: (0, _stringify2.default)(settings)
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            body = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt('return', body);

          case 10:
            throw body;

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function updateSettings(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = updateSettings;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/updateSettings.js
// module id = 710
// module chunks = 11